import { TrendingUp, TrendingDown } from "lucide-react"

const WalletCard = ({ balance, currency, change, type }) => {
  const isPositive = change >= 0

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 transition-all hover:shadow-md">
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-sm text-gray-500">{type}</p>
          <h3 className="text-2xl font-bold text-gray-800">{balance}</h3>
        </div>
        <div className={`p-2 rounded-full ${isPositive ? "bg-green-100" : "bg-red-100"}`}>
          {isPositive ? (
            <TrendingUp className="h-5 w-5 text-green-600" />
          ) : (
            <TrendingDown className="h-5 w-5 text-red-600" />
          )}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">Currency</span>
          <span className="text-sm font-medium text-gray-700">{currency}</span>
        </div>
      </div>
    </div>
  )
}

export default WalletCard
